import {addToBasket} from '@js/actions/basketActions';
import {trackTrialAction} from '@js/actions/trackingActions';
import {enableUserTrial} from '@js/actions/trialActions';

import {basketStore} from '@js/stores/basketStore';

import Notification from '@js/components/layouts/notification';

import {checkoutPath} from '@js/constants/routesHelper';

import $ from '@js/modules/selector';
import AnalyticsService from '@js/modules/analyticsService';

class TrialManager {
    _isBannerVisible = false;

    _minNavbarScroll = 200;
    _lastScrollTop = 0;

    _bannerId = '#trial-banner';
    _startButtonId = '#trial-start-button';
    _closeButtonId = '#trial-banner-close';

    _$scrollNavbar = null;
    _maxBannerShowAfterClose = 4;
    // _displayBannerStorageKey = 'trial-banner-display-count';
    _closeBannerStorageKey = 'trial-banner-close-count';

    /* Public methods
    ******************** */
    initialize = () => {
        if (!window.features.trial?.active) {
            return;
        }

        this._isBannerVisible = true;

        this._manageBanner();
        this._handleCloseBanner();

        this._handleStartButtonClick();
    };

    /* Private methods
    ******************** */
    _manageBanner = () => {
        if (window.sessionStorage) {
            // let displayCount = window.sessionStorage.getItem(this._displayBannerStorageKey);
            // displayCount = displayCount ? parseInt(displayCount) : 0;

            let closeCount = window.sessionStorage.getItem(this._closeBannerStorageKey);
            closeCount = closeCount ? parseInt(closeCount) : 0;

            // displayCount >= this._maxBannerShowAfterClose ||
            if (closeCount >= this._maxBannerShowAfterClose) {
                this._hideBanner();
                return;
            }
        }

        this._showBanner();

        // detect scroll top or down
        this._$scrollNavbar = document.getElementById('trial-banner');
        if (this._$scrollNavbar && this._isBannerVisible) {
            // Already defined in CSS
            // computePaddingTop();

            if (navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1) {
                // Remove annoying transform properties with modal
                this._$scrollNavbar.style['-webkit-transform'] = '';

                // Safari doesn't support scroll
                // return;
            }

            window.addEventListener('scroll', this._handleWindowScroll);
        }
    };

    _handleWindowScroll = () => {
        // var scrollTop = window.scrollTop;
        const scrollTop = ((document.compatMode || '') === 'CSS1Compat') ? document.documentElement.scrollTop : document.body.scrollTop;

        if (scrollTop < this._lastScrollTop || scrollTop < this._minNavbarScroll) {
            this._$scrollNavbar.classList.remove('scrolled-down');
            this._$scrollNavbar.classList.add('scrolled-up');
        } else {
            this._$scrollNavbar.classList.remove('scrolled-up');
            this._$scrollNavbar.classList.add('scrolled-down');
        }

        this._lastScrollTop = scrollTop;
    };

    _handleCloseBanner = () => {
        const $closeButton = $(this._closeButtonId);
        if (!$closeButton) {
            return;
        }

        $closeButton.on('click', (event) => {
            event.preventDefault();

            this._hideBanner();

            if (window.sessionStorage) {
                let closeCount = window.sessionStorage.getItem(this._closeBannerStorageKey);
                closeCount = closeCount ? (parseInt(closeCount) + 1) : 1;

                window.sessionStorage.setItem(this._closeBannerStorageKey, closeCount.toString());
            }
        });
    };

    _showBanner = () => {
        const $banner = $(this._bannerId);
        if (!$banner) {
            return;
        }

        // if (window.sessionStorage) {
        //     let displayCount = window.sessionStorage.getItem(this._displayBannerStorageKey);
        //     displayCount = displayCount ? (parseInt(displayCount) + 1) : 1;
        //
        //     window.sessionStorage.setItem(this._displayBannerStorageKey, displayCount.toString());
        // }

        this._isBannerVisible = true;

        $banner.removeClass('scroll-up');
        $banner.removeClass('scroll-down');
        $banner.removeClass('hidden');
        $banner.addClass('block');
    };

    _hideBanner = () => {
        const $banner = $(this._bannerId);
        if (!$banner) {
            return;
        }

        this._isBannerVisible = false;

        window.removeEventListener('scroll', this._handleWindowScroll);

        $banner.removeClass('scroll-up');
        $banner.removeClass('scroll-down');
        $banner.removeClass('block');
        $banner.addClass('hidden');
    };

    _handleStartButtonClick = () => {
        const $startButton = $(this._startButtonId);
        if (!$startButton) {
            return;
        }

        $startButton.on('click', (event) => {
            event.preventDefault();

            const action = $startButton.data('action');
            const productId = $startButton.data('product-id');

            this._disableBasketButton();

            if (action === 'start_trial') {
                trackTrialAction('start_trial', 'banner');
                this._startTrial();
            } else {
                trackTrialAction('add_to_basket', 'banner');
                this._addToBasket(productId);
            }
        });
    };

    _startTrial = () => {
        if (!window.currentUserId) {
            this._enableBasketButtons();
            return;
        }

        enableUserTrial(window.currentUserId)
            .then((response) => {
                if (response.errors) {
                    Notification.error(response.errors.join ? response.errors.join(', ') : response.errors);
                    this._enableBasketButtons();
                    return;
                }

                if (response.trial_active) {
                    window.location.reload();
                } else {
                    this._enableBasketButtons();
                }
            })
            .catch(() => {
                this._enableBasketButtons();
            });
    };

    _addToBasket = (productId) => {
        addToBasket(productId, 'trial_banner')
            .then((response) => {
                if (response.errors) {
                    this._enableBasketButtons();
                    return;
                }

                const basket = response.basket;
                const product = basket?.products?.first();

                basketStore.basket = basket;

                AnalyticsService.trackAddToBasket(product.slug, product.name, basket.totalAmount)
                    .then(() => {
                        window.location = checkoutPath();
                    });
            });
    };

    _enableBasketButtons = () => {
        const $addBasketButton = $(this._startButtonId);
        const $addBasketLoader = $(this._startButtonId + '-loader');

        if ($addBasketButton) {
            $addBasketButton.removeAttr('disabled');
        }

        if ($addBasketLoader) {
            $addBasketLoader.addClass('hidden');
            $addBasketLoader.removeClass('inline');
        }
    };

    _disableBasketButton = () => {
        const $addBasketButton = $(this._startButtonId);
        const $addBasketLoader = $(this._startButtonId + '-loader');

        if ($addBasketButton) {
            $addBasketButton.attr('disabled', 'disabled');
        }

        if ($addBasketLoader) {
            $addBasketLoader.removeClass('hidden');
            $addBasketLoader.addClass('inline');
        }
    };
}

export default new TrialManager();
